import type { SvgIconProps } from '@mui/material';
import type { ComponentType } from 'react';
import * as CustomIcons from './custom';
import { exportNameToIconName, type ExportNameToIconName } from './iconName';
import * as MuiIcons from './mui';

function buildIconMap<T extends Record<string, ComponentType<SvgIconProps>>>(
  exports: T
): { [K in keyof T as ExportNameToIconName<K & string>]: ComponentType<SvgIconProps> } {
  return Object.fromEntries(
    Object.entries(exports).map(([exportName, Icon]) => [exportNameToIconName(exportName), Icon])
  ) as { [K in keyof T as ExportNameToIconName<K & string>]: ComponentType<SvgIconProps> };
}

export const iconMap = {
  ...buildIconMap(MuiIcons),
  ...buildIconMap(CustomIcons)
};

export type IconName = keyof typeof iconMap;

export function getIconComponent(name: IconName): ComponentType<SvgIconProps> {
  return iconMap[name];
}
